import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { Line, TableStyleThree } from '../styles';
import { FinancialPathStyle } from './styles';
import { RebuttalHeader } from '../shared';
import { SHARED_STYLES } from '@constants';

export const FinancialPath = () => {
    const { t } = useTranslation();
    const { data, desktop } = useSlideData();
    const { details } = data;
    const { red } = SHARED_STYLES;
    const slideKey = 'financial_path';

    const { currentBalance, currentInterest, currentPayments,
    timeToPayOffBalance, interestPaid, totalAmountPaid } = details;

    return (
        <FinancialPathStyle desktop={desktop}>
            <RebuttalHeader
                description={t(`${slideKey}.current_balance`)}
                balance={currentBalance} />
            <Line />
            <div>{t(`${slideKey}.description`)}</div>
            <TableStyleThree rowHeight='46px'>
                <thead>
                    <tr>
                        <th>{t(`${slideKey}.current_interest_rate`)}</th>
                        <th>{t(`${slideKey}.current_payment`)}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{currentInterest}</td>
                        <td>{currentPayments}</td>
                    </tr>
                </tbody>
            </TableStyleThree>
            <TableStyleThree rowHeight='46px' background={red}>
                <thead>
                    <tr>
                        <th>{t(`${slideKey}.time_to_pay_off`)}</th>
                        <th>{t(`${slideKey}.interest_paid`)}</th>
                        <th>{t(`${slideKey}.total_amount_paid`)}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{timeToPayOffBalance}</td>
                        <td>{interestPaid}</td>
                        <td>{totalAmountPaid}</td>
                    </tr>
                </tbody>
            </TableStyleThree>
        </FinancialPathStyle>
    );
};

export default FinancialPath;
